{
    "Omclient": "Omnichannel-Client:",
    "OmclientAgentValidation": "Ein Omnichannel-Client benötigt einen Endpunkt-ACD-Agenten",
    "DeviceHint": "Wählen Sie den Supervisor-Endpunkt aus, um die integrierten browserbasierten Anrufsteuerungen zuzulassen",
    "OmnichannelAgent": "Omnichannel-Agent:",
    "NoneSelected": "[Nichts ausgewählt]",
    "NoAssociatedDevice": "[Kein zugeordnetes Gerät]",
    "NoAssociatedAgent": "[Kein zugeordneter ACD-Agent]",
    "ExtensionEndpoint_PermissionsNote": "Legen Sie die Berechtigungen für die Benutzerzugriffsebene fest.",
    "ExtensionEndpoint_CmEnvironment": "CME:",
    "ExtensionEndpoint_TelServer": "Telefonieserver:",
    "ExtensionEndpoint_Partition": "Teilung:",
    "ExtensionEndpoint_Device": "Gerät:",
    "ExtensionEndpoint_AndOrAgent": "Und\/oder Agent:",
    "NAME": "ExtensionEndpoint",
    "ExtensionEndpoint_Validation_Professional_Device": "Ein Professional-Benutzer muss einen Geräteendpunkt festgelegt haben",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Für einen CXA-Benutzer, der nicht verwendet wird, muss ein Geräteendpunkt festgelegt sein",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Ein Callcenter-Agent muss einen Agent-Endpunkt haben",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Ein CXA-Premium-Benutzer muss einen Agenten-Endpunkt eingestellt haben"
}